import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=47b468ca&scoped=true&"
import script from "./Submit.vue?vue&type=script&lang=js&"
export * from "./Submit.vue?vue&type=script&lang=js&"
import style0 from "./Submit.vue?vue&type=style&index=0&id=47b468ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b468ca",
  null
  
)

export default component.exports